module.exports = __webpack_public_path__ + "static/media/coachella-1.d16c1679.jpg";